export default __webpack_public_path__ + "static/media/startlater_1@3x.2ddb970a.jpg";